import { connect } from 'react-redux'

import { fetchMyEventsSterams, fetchRemoveMyEvent, fetchUpdateMyEvent } from './myEventsActions'
import MyEvents from './MyEvents'

const mapStateToProps = (state) => ({
  isLoading: state.myEvents.isLoading,
  streams: state.myEvents.streams,
  userId: state.authorization.userId
})

const mapDispatchToProps = (dispatch) => ({
  fetchMyStreams: (userId) => dispatch(fetchMyEventsSterams(userId)),
  fetchRemoveMyEvent: (eventId) => dispatch(fetchRemoveMyEvent(eventId)),
  updateMyEvent: (stream) => dispatch(fetchUpdateMyEvent(stream))
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  fetchMyStreams: () => dispatchProps.fetchMyStreams(stateProps.userId),
  fetchRemoveMyEvent: (eventId) => dispatchProps.fetchRemoveMyEvent(eventId),
  updateMyEvent: (stream) => dispatchProps.updateMyEvent(stream)
})
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(MyEvents)
